import { State, FEATURE_KEY } from './checkout.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getCheckoutState = createFeatureSelector<State>(FEATURE_KEY);

export const selectCart = createSelector(getCheckoutState, state => state.cart);

export const selectAddresses = createSelector(
  getCheckoutState,
  state => state.addresses
);

export const selectLoading = createSelector(
  getCheckoutState,
  state => state.loading
);

export const selectError = createSelector(
  getCheckoutState,
  state => state.error
);

export const selectOrderId = createSelector(
  getCheckoutState,
  state => state.orderId
);

export const selectCoupon = createSelector(
  getCheckoutState,
  state => state.coupon
);

export const getSelectedPaymentMethodId = createSelector(
  getCheckoutState,
  state => state.selectedPaymentMethodId
);

export const selectCvv = createSelector(getCheckoutState, state => state.cvv);
